import OnlineOrderValuesModel from "../../../../services/models/formModels/onlineOrderValues.model";
import CustomText from "../../../atomic/CustomText";
import DetailRenderer from "../DetailRenderer";

function LaboratoryInformationReview({
  values,
}: {
  values: OnlineOrderValuesModel;
}) {
  return (
    <div id="laboratory info">
      <CustomText
        text={
          values.testTypeId === 8
            ? "Specimen Information"
            : "Laboratory Information"
        }
        fontWeight="font-medium"
        className="reviewCardHeading my-5"
      />
      <p>Type of specimen being submitted for testing</p>

      <p className="my-2">{values.laboratoryInfo.typeOfSpecimen}</p>

      <div className="reviewCard">
        {/* Refactored to if-else for clarity and lint compliance */}
        {(() => {
          if (values.testTypeId === 9) {
            return (
              <DetailRenderer
                data={{
                  // nameOfFacility: values.laboratoryInfo.labortaryName,
                  dateOfCollection: values.laboratoryInfo.dateOfCollection,
                  // specimenId: values.laboratoryInfo.specimenId,
                  medicarePullDate: values.laboratoryInfo.medicarePullDate,
                  // phone: values.laboratoryInfo.labortaryPhone,
                  // fax: values.laboratoryInfo.labortaryFax,
                  sampleLocationA: values.laboratoryInfo.sampleLocationA,
                  sampleLocationB: values.laboratoryInfo.sampleLocationB,
                  // isConsideredForTherapy: values.isConsideredForTherapy,
                }}
                groupFields={[
                  // "nameOfFacility",
                  "dateOfCollection",
                  "specimenId",
                  "medicarePullDate",
                  // "phone",
                  // "fax",
                  "sampleLocationA",
                  "sampleLocationB",
                  // "isConsideredForTherapy",
                ]}
                hiddenFields={[]}
                MainHeading="Laboratory"
              />
            );
          } else if (values.testTypeId === 5) {
            return (
              <DetailRenderer
                data={{
                  nameOfFacility: values.laboratoryInfo.labortaryName,
                  dateOfCollection: values.laboratoryInfo.dateOfCollection,
                  specimenId: values.laboratoryInfo.specimenId,
                  medicarePullDate: values.laboratoryInfo.medicarePullDate,
                  phone: values.laboratoryInfo.labortaryPhone,
                  fax: values.laboratoryInfo.labortaryFax,
                  pathologist: "",
                  tumorSite: values.tumorSite,
                }}
                groupFields={[
                  "nameOfFacility",
                  "dateOfCollection",
                  "specimenId",
                  "medicarePullDate",
                  "phone",
                  "fax",
                  "pathologist",
                  "tumorSite",
                ]}
                hiddenFields={[]}
                MainHeading="Laboratory"
              />
            );
          } else if (values.testTypeId === 8) {
            return (
              <DetailRenderer
                data={{
                  dateOfCollection: values.laboratoryInfo.dateOfCollection,
                  medicarePullDate: values.laboratoryInfo.medicarePullDate,
                  isTelehealth: values.isTeleHealth === false ? 'No' : 'Yes',
                  tubeBarCode: values.tubeBarcode,
                  facilityType: values.facilityType,
                }}
                groupFields={[
                  "dateOfCollection",
                  "medicarePullDate",
                  "tubeBarCode",
                  "isTelehealth",
                  "facilityType",
                ]}
                hiddenFields={[]}
                MainHeading="Specimen"
              />
            );
          } else {
            return (
              <DetailRenderer
                data={{
                  nameOfFacility: values.laboratoryInfo.labortaryName,
                  dateOfCollection: values.laboratoryInfo.dateOfCollection,
                  specimenId: values.laboratoryInfo.specimenId,
                  medicarePullDate: values.laboratoryInfo.medicarePullDate,
                  phone: values.laboratoryInfo.labortaryPhone,
                  fax: values.laboratoryInfo.labortaryFax,
                }}
                groupFields={[
                  "nameOfFacility",
                  "dateOfCollection",
                  "specimenId",
                  "medicarePullDate",
                  "phone",
                  "fax",
                ]}
                hiddenFields={[]}
                MainHeading="Laboratory"
              />
            );
          }
        })()}
      </div>
    </div>
  );
}
export default LaboratoryInformationReview;
